import DOMPurify from "isomorphic-dompurify";
import React from "react";

import { Container } from "@brexhq/next/src/components/layout/Container/Container";
import { SanityIFrameProps } from "@brexhq/shared/types/modules/BlockRowsModule/BlockRowItems";

type Props = Omit<SanityIFrameProps, "_key" | "_type">;

export const IFrame = ({ iFrameCode }: Props) => (
  <Container
    width="100%"
    dangerouslySetInnerHTML={{
      __html: DOMPurify.sanitize(iFrameCode, {
        // By default, DOMPurify removes iFrames. ALLOWED_TAGS here specifies that ONLY iFrames are allowed.
        ALLOWED_TAGS: ["iframe"],
        //  Allows a few tags that the Spotify iFrame uses but DOMPurify strips by default.
        ADD_ATTR: ["allow", "allowfullscreen", "frameBorder"],
      }),
    }}
  />
);
